module.exports = __webpack_public_path__ + "img/logo5.45f03804.png";